import { FormikProps } from 'formik'

import { useForm } from 'modules/core/hooks/useForm'
import { TrackingProperties, track, trackingEvents } from 'modules/core/lib/Tracking'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useCreateCustomTimeRangeCategory } from 'modules/attendance/hooks/useCreateCustomTimeRangeCategory'

import { minutesToCents } from '../timeConverter'

const DEFAULT_MINUTES = 60

export interface CustomTimeRangeCategoryFormType {
  id?: number
  attendanceEmployeesSettingId: number
  rawMinutesInCents: number
  equivalentMinutesInCents: number
  timeSettingsCustomTimeRangeCategoryId: number
}

interface Props {
  settingId: number
}

const CreateAttendanceCustomTimeRangeCategoryForm = ({ settingId }: Props) => {
  const { create } = useCreateCustomTimeRangeCategory()

  const trackEvent = () => {
    const properties: TrackingProperties = {
      category_id: form.values.timeSettingsCustomTimeRangeCategoryId,
      raw_minutes: form.values.rawMinutesInCents,
      equivalent_minutes: form.values.equivalentMinutesInCents,
    }

    track(trackingEvents.timeTracking.addWorkTimeCategoryValue, properties)
  }

  const defaultValues: CustomTimeRangeCategoryFormType = {
    attendanceEmployeesSettingId: settingId,
    rawMinutesInCents: DEFAULT_MINUTES,
    equivalentMinutesInCents: DEFAULT_MINUTES,
    timeSettingsCustomTimeRangeCategoryId: 0,
  }

  const form: FormikProps<CustomTimeRangeCategoryFormType> =
    useForm<CustomTimeRangeCategoryFormType>({
      defaultValues: defaultValues,
      onSubmit: async (data, { setErrors }) => {
        const payload = {
          attendanceEmployeesSettingId: settingId,
          timeSettingsCustomTimeRangeCategoryId: Number(data.timeSettingsCustomTimeRangeCategoryId),
          rawMinutesInCents: minutesToCents(data.rawMinutesInCents),
          equivalentMinutesInCents: minutesToCents(data.equivalentMinutesInCents),
        }
        const result = await create(payload)
        const handled = handleResult(result, setErrors)
        if (handled.success) {
          trackEvent()
          app.setFlash({
            type: 'correct',
            message: i18n.t('common.saved_successfully'),
          })
          form.resetForm()
        } else {
          app.setFlash({
            type: 'wrong',
            message: i18n.t('time_tracking.settings.time_blocks.categories.modals.name_error'),
          })
          form.resetForm()
        }

        return handled
      },
    })

  return form
}

export default CreateAttendanceCustomTimeRangeCategoryForm
